module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "generalContainer",
    attrs: {
      "ondragstart": "return false;",
      "ondrop": "return false;"
    }
  }, [_c('NotificationContainer'), _vm._v(" "), (_vm.loadedRequisites) ? _c('router-view') : _vm._e(), _vm._v(" "), _c('NoCookiesModal')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5930af97"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 317
// module chunks = 22